/* TPL Recently viewed (2026-10-29, round 3 d11).
   Product page: save {handle,title,url,img,price} to localStorage (max 8, newest first, unique).
   Any page: draw the last N (default 4) other products as a swipe row. Hidden when empty.
   Everything wrapped in try/catch: private windows and blocked storage just show nothing.
   Round 5 (2026-10-30): the saved image is the artwork-first variant shot; on a mat/frame swap
   the saved card follows the variant (cfg.vimg). Cards draw a 4:5 box, image contained. */
(function () {
  'use strict';
  var KEY = 'tpl-recent-products';
  var MAX = 8;

  function load() {
    try {
      var list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) { return []; }
  }

  function valid(p) {
    return p && typeof p.handle === 'string' && typeof p.title === 'string' &&
      typeof p.url === 'string' && p.url.charAt(0) === '/' && p.url.charAt(1) !== '/' &&
      !(p.handle.indexOf('la-siesta-') === 0 && !/\/GS-/.test(p.img || ''));
  }

  function save(cur) {
    var next = [cur].concat(load().filter(function (p) { return valid(p) && p.handle !== cur.handle; })).slice(0, MAX);
    try { window.localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) { /* blocked or full */ }
    return next;
  }

  function track(p) {
    try { if (window.tplTrack) window.tplTrack('tpl_recent_tap', { handle: p.handle }); } catch (e) { /* ignore */ }
  }

  function card(p) {
    var li = document.createElement('li');
    li.className = 'tpl-rv__item';
    var a = document.createElement('a');
    a.className = 'tpl-rv__card';
    a.href = p.url;
    var media = document.createElement('span');
    media.className = 'tpl-rv__media';
    if (typeof p.img === 'string' && /^(https:)?\/\//.test(p.img)) {
      var img = document.createElement('img');
      img.src = p.img;
      img.alt = '';
      img.width = 480;
      img.height = 600;
      img.loading = 'lazy';
      img.decoding = 'async';
      media.appendChild(img);
    }
    var name = document.createElement('span');
    name.className = 'tpl-rv__name';
    name.textContent = p.title;
    a.appendChild(media);
    a.appendChild(name);
    if (p.price) {
      var price = document.createElement('span');
      price.className = 'tpl-rv__price';
      price.textContent = p.price;
      a.appendChild(price);
    }
    a.addEventListener('click', function () { track(p); });
    li.appendChild(a);
    return li;
  }

  /* Product page: keep the saved card on the variant being looked at. */
  var following = false;
  function follow(cfg) {
    if (following || !cfg.vimg || typeof cfg.vimg !== 'object') return;
    following = true;
    var last = '';
    function sync() {
      var input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      var id = input ? String(input.value) : '';
      var url = id && cfg.vimg[id];
      if (!url || id === last || typeof url !== 'string' || !/^(https:)?\/\//.test(url)) return;
      last = id;
      var cur = {};
      for (var k in cfg.current) if (Object.prototype.hasOwnProperty.call(cfg.current, k)) cur[k] = cfg.current[k];
      cur.img = url;
      save(cur);
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') setTimeout(sync, 0);
    });
    try {
      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
        window.subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(sync, 0); });
      }
    } catch (e) { /* ignore */ }
  }

  function init(root) {
    if (root.hasAttribute('data-rv-ready')) return;
    root.setAttribute('data-rv-ready', '');
    var cfgEl = root.querySelector('[data-rv-config]');
    var row = root.querySelector('[data-rv-row]');
    var cfg = null;
    try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : 'null'); } catch (e) { cfg = null; }
    if (!cfg || !row) return;

    var list;
    var curHandle = '';
    if (cfg.current && valid(cfg.current)) {
      curHandle = cfg.current.handle;
      list = save(cfg.current);
      follow(cfg);
    } else {
      list = load();
    }
    var show = Math.max(1, Math.min(6, parseInt(cfg.show, 10) || 4));
    var items = list.filter(function (p) { return valid(p) && p.handle !== curHandle; }).slice(0, show);
    if (!items.length) { root.hidden = true; return; }
    row.textContent = '';
    items.forEach(function (p) { row.appendChild(card(p)); });
    root.hidden = false;
  }

  function boot() {
    document.querySelectorAll('[data-tpl-rv]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
